import { useEffect, useState } from "react";

import { RadioButton } from "@king-ict/eupisi-ui/components";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { DEFAULT_REQUEST } from "./constants";
import {
  getRequest,
  createSchoolCandidate,
} from "../../api/Request/RequestApi";
import { useAppDispatch } from "../../app/store";
import {
  ContentArea,
  ToolbarTop,
  CountySelect,
  ToolbarEdit,
  FormCard,
  InstitutionSelect,
  RequestHeader,
} from "../../components";
import { useAuth } from "../../hooks/auth/useAuth";
import { ValidationFailure } from "../../models";
import {
  Request,
  CreateRequestSchoolCandidate,
  RequestSchoolCandidateCreateType,
} from "../../models/Request";
import { ClaimType } from "../../models/User";
import { requestAdminDetailsUrl } from "../../routes/routes";
import { resetIsEdited, setIsEdited } from "../../slices/applicationSlice";

export function RequestSchoolCandidateCreate() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const auth = useAuth();

  const createDefaultCreate = (): CreateRequestSchoolCandidate => {
    return {
      requestId: +id,
      uoguCountyId:
        auth.currentRole?.locations && auth.currentRole.locations.length > 0
          ? auth.currentRole.locations[0]
          : 1,
      requestSchoolCandidateCreateType:
        RequestSchoolCandidateCreateType.Institution,
    };
  };

  const [item, setItem] = useState<Request>(DEFAULT_REQUEST);
  const [create, setCreate] = useState<CreateRequestSchoolCandidate>(
    createDefaultCreate()
  );
  const [errors, setErrors] = useState<ValidationFailure[]>();

  useEffect(() => {
    (async () => {
      if (id && id !== "0") {
        var result = await getRequest(+id);
        if (result) {
          setItem(() => result);
        }
      }
    })();
    dispatch(resetIsEdited());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleCreateTypeChange = (e: any) => {
    const createType = Number.parseInt(e.target.value);

    const newCreate: CreateRequestSchoolCandidate = {
      ...create,
      requestSchoolCandidateCreateType: createType,
    };
    switch (createType) {
      case RequestSchoolCandidateCreateType.County:
        newCreate.institutionId = undefined;
        break;
      case RequestSchoolCandidateCreateType.Institution:
        break;
    }
    setCreate(newCreate);
    dispatch(setIsEdited());
  };
  const handleInstitutionChange = (e: any) => {
    const institutionId = Number.parseInt(e.target.value);
    if (!isNaN(institutionId)) {
      const newCreate: CreateRequestSchoolCandidate = {
        ...create,
        institutionId: institutionId,
      };
      setCreate(newCreate);
    }
    dispatch(setIsEdited());
  };
  const handleCountyChange = (e: any) => {
    const countyId = Number.parseInt(e.target.value);
    const newCreate: CreateRequestSchoolCandidate = {
      ...create,
      institutionId: undefined,
      uoguCountyId: countyId,
    };
    setCreate(newCreate);
    dispatch(setIsEdited());
  };

  return (
    <ContentArea>
      <ToolbarTop
        showAdd={"hide"}
        showBack={"show"}
        showEdit={"hide"}
        pageTitle={t("request.addSchoolCandidatePageTitle")}
        errors={errors}
      />
      <RequestHeader request={item} />
      <FormCard>
        <Row>
          <Col md={12}>
            <RadioButton
              label={t("request.institutionSchoolCandidate")}
              ariaLabel="institution"
              key="institution"
              name="institution"
              checked={
                create.requestSchoolCandidateCreateType ===
                RequestSchoolCandidateCreateType.Institution
              }
              onChange={handleCreateTypeChange}
              value={RequestSchoolCandidateCreateType.Institution}
            />
          </Col>
        </Row>
        <Row>
          <Col md={1}></Col>
          <Col md={5}>
            <InstitutionSelect
              label={t("common.schoolCandidateModel.institutionList")}
              name={nameof<typeof create>("institutionId")}
              value={create.institutionId}
              onChange={handleInstitutionChange}
              countyIds={
                auth.currentRole?.claimType === ClaimType.County &&
                auth.currentRole?.locations &&
                auth.currentRole?.locations
                  ? auth.currentRole.locations
                  : undefined
              }
              disabled={
                create.requestSchoolCandidateCreateType !==
                RequestSchoolCandidateCreateType.Institution
              }
              errorText={
                errors?.find((e) => e.propertyName === "InstitutionId")?.message
              }
              showUser={true}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RadioButton
              label={t("request.countySchoolCandidate")}
              ariaLabel="county"
              key="county"
              name="county"
              checked={
                create.requestSchoolCandidateCreateType ===
                RequestSchoolCandidateCreateType.County
              }
              onChange={handleCreateTypeChange}
              value={RequestSchoolCandidateCreateType.County}
            />
          </Col>
        </Row>
        <Row>
          <Col md={1}></Col>
          <Col md={5}>
            <CountySelect
              label={t("common.schoolCandidateModel.uoguCounty")}
              name={"schoolCandidate.uoguCounty"}
              value={create.uoguCountyId}
              onChange={handleCountyChange}
              disabled={
                create.requestSchoolCandidateCreateType !==
                RequestSchoolCandidateCreateType.County
              }
              errorText={
                errors?.find((e) => e.propertyName === "UOGUCountyId")?.message
              }
            />
          </Col>
        </Row>
      </FormCard>
      <ToolbarEdit
        showCancel={"show"}
        showSave={"show"}
        redirectUrlSaveOK={() => requestAdminDetailsUrl(+id)}
        handleSave={async () => createSchoolCandidate(create)}
        setSaveErrors={setErrors}
        showCustom={false}
      />
    </ContentArea>
  );
}
